import { render, staticRenderFns } from "./PEAsylumAssistant.vue?vue&type=template&id=2de51cd9&"
import script from "./PEAsylumAssistant.vue?vue&type=script&lang=js&"
export * from "./PEAsylumAssistant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports